import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=40e22bfa"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e22bfa')) {
      api.createRecord('40e22bfa', component.options)
    } else {
      api.reload('40e22bfa', component.options)
    }
    module.hot.accept("./actions.vue?vue&type=template&id=40e22bfa", function () {
      api.rerender('40e22bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/router/components/actions.vue"
export default component.exports